import { useCallback, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Category, Row } from "../types";
import styles from "./styles.module.scss";
import reusedStyles from "../styles.module.scss";
import { faqData } from "./faq-data";
import { RegularIcon } from "../../../../Shared/Icons/regular";

const ContentPlaceholder = ({ question }: { question: Row }) => (
	<motion.div
		variants={{ collapsed: { scale: 1 }, open: { scale: 1 } }}
		transition={{ duration: 0.4 }}
		className={`accordionContent ${styles.dynamicContent}`}
	>
		{question.content}
	</motion.div>
);

// const accordionBody = {
// 	enter: {
// 		height: "auto"
// 	},
// 	exit: {
// 		height: 0
// 	}
// };

const OpenIcon = () => <RegularIcon className="right open" icon={{ icon: "minus" }} />;
const ClosedIcon = () => <RegularIcon className="right" icon={{ icon: "plus" }} />;

//
// const AccordionRow = ({ title, children }: { title: string, children: ReactNode }) => {
// 	const [isOpen, setOpen] = useState<boolean>(false);
//
// 	return (<div className="accordion">
// 		<div className={`title ${isOpen ? 'open' : ''}`} onClick={() => setOpen(!isOpen)}>
// 			{title}
// 			{open ?
// 				// 				:
// 				// 			}
// 		</div>
// 		<motion.div
// 			className={`contentHolder ${isOpen ? 'open' : ''}`}
// 			animate={isOpen ? 'enter' : 'exit'}
// 			initial="exit"
// 			variants={accordionBody}
// 		>
// 			<div className="content">
// 				{children}
// 			</div>
// 		</motion.div>
// 	</div>
// 	)
// };

const Sections = ({ data, onSectionChange, activeSection }: { data: Category[], onSectionChange: (val: number) => void, activeSection: number }) => {
	return (
		<div className={styles.sections}>
			<ul>
				{data.map((item, i) => {
					return (<li key={i}><button className={activeSection === i ? "active" : ""} onClick={() => onSectionChange(i)}>{item.title}</button></li>);
				})}
			</ul>
		</div>
	)
}

const AccordionRow = ({ question, rowIndex, expanded, setExpanded }: { question: Row, rowIndex: number, expanded: number, setExpanded: (val: number) => void }) => {
	const isOpen = rowIndex === expanded;

	// By using `AnimatePresence` to mount and unmount the contents, we can animate
	// them in and out while also only rendering the contents of open accordions
	return (
		<div className={`${isOpen ? 'active' : 'inactive'} accordion-row`}>
			<div className="title">
				<motion.button
					className={""}
					initial={false}
					animate={isOpen ? { backgroundColor: "#DDD" } : {}}
					onClick={() => setExpanded(isOpen ? -1 : rowIndex)}
				><span>{question.question}</span>{isOpen ? <OpenIcon /> : <ClosedIcon />}</motion.button>
			</div>
			<AnimatePresence initial={false}>
				{isOpen && (
					<motion.section
						key="content"
						initial="collapsed"
						animate="open"
						exit="collapsed"
						variants={{
							open: { opacity: 1, height: "auto" },
							collapsed: { opacity: 0, height: 0 }
						}}
						transition={{ duration: 0.2, ease: [0.04, 0.62, 0.23, 0.98] }}
					>
						<ContentPlaceholder question={question} />
					</motion.section>
				)}
			</AnimatePresence>
		</div>
	);
};

const AccordionSection = ({ section, sectionIndex, isActive }: { section: Category, sectionIndex: number, isActive: boolean }) => {
	const [activeRow, setRow] = useState<number>(-1);

	return (
		<div className={`${styles.accordionWrapper}`} id={`accordion-${sectionIndex}`}>
			<div className={`accordionInner ${isActive ? "active" : ""}`}>
				{section.items.map((row, i) => {
					return (
						<AccordionRow key={i} question={row} rowIndex={i} expanded={activeRow} setExpanded={() => setRow(i)} />
					);
				})}
			</div>
		</div>
	);
}

const AccordionSections = ({ data, selectedSection }: { data: Category[], selectedSection: number }) => {
	return (
		<>
			{data.map((section, s) => {
				return (<AccordionSection sectionIndex={s} section={section} key={s} isActive={s === selectedSection} />);
			})}
		</>
	);
};

export default function Faq() {
	const [selectedSection, setSelectedSection] = useState<number>(0);

	const onChange = useCallback((val: number) => {
		setSelectedSection(val);
	}, []);

	return (
		<div className={styles.accordionSection}>
			<div className={styles.section}>
				<div className="container">
					<h2 className={reusedStyles.heading}>FAQ</h2>
					<Sections data={faqData} onSectionChange={onChange} activeSection={selectedSection} />
					<AccordionSections data={faqData} selectedSection={selectedSection} />
				</div>
			</div>
		</div>
	);
}
